import styled from '@emotion/styled';
import PhoneIcon from '@portalterreno/react-ui-icons/PhoneIcon';

const StyledPhoneIcon = styled(PhoneIcon)({
  marginLeft: 5
});

export default StyledPhoneIcon;
